//loader.service.ts
import { Injectable } from "@angular/core";
import { BehaviorSubject, NEVER, defer } from "rxjs";
import { finalize, share } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class LoaderService {
  public isLoading = new BehaviorSubject(false);

  public readonly loader$ = defer(() => {
    this.show();
    return NEVER.pipe(
      finalize(() => {
        this.hide();
      })
    );
  }).pipe(share());

  constructor() { }

  public show(): void {

    Promise.resolve(null).then(() => {
      if (!this.isLoading.value) {
        this.isLoading.next(true);
      }

    })

  }

  public hide(): void {

    this.isLoading.next(false);

  }
}
